<template>
  <div :class="['reviews', {'no-reviews': !REVIEWS.length}]">
    <div class="reviews__inner">
      <h2 class="reviews__title">
        Отзывы
      </h2>

      <template
        v-if="reviewsInitialLoadingDone"
      >
        <div
          class="reviews__stats"
        >
          <review-stats
            @show-form="showReviewForm"
          />
        </div>
        <div class="reviews__all-reviews">
          <product-reviews :product-code="PRODUCT.code" />
        </div>
      </template>

      <template
        v-else
      >
        <div class="reviews__loader">
          <transition name="fade">
            <ui-loader size="60" />
          </transition>
        </div>
      </template>

      <review-modal
        :shown="isFormShown"
        :product-code="PRODUCT.code"
        @close="hideReviewForm"
      />
    </div>
  </div>
</template>

<script>
import ReviewStats from './review-stats/review-stats.vue';
import ProductReviews from './product-reviews.vue';
import ReviewModal from './review-modal.vue';
import { mapActions, mapGetters } from 'vuex';
import { productGtmEvents } from '@/gtm/product';

export default {
  name: 'reviews',

  components: {
    ReviewStats,
    ProductReviews,
    ReviewModal,
  },

  data() {
    return {
      isFormShown: false,
      reviewsInitialLoadingDone: false,
    };
  },

  computed: {
    ...mapGetters({
      LOGGED_IN: 'user/loggedIn',
      REVIEWS: 'product/productReviews',
      PRODUCT: 'product/item',
    }),

    productId() {
      return this.$route?.params?.id;
    },
  },

  async mounted() {
    await this.loadProductReviews({ productId: this.productId });
    this.reviewsInitialLoadingDone = true;
  },

  methods: {
    ...mapActions({
      loadProductReviews: 'product/loadProductReviews',
    }),

    showReviewForm() {
      this.$f.login()
        .then(() => {
          this.isFormShown = true;

          productGtmEvents.reviews.leaveReview({ productCode: this.PRODUCT?.code });
        })
        .catch(() => {});
    },

    hideReviewForm() {
      this.isFormShown = false;
    }
  }
}
</script>

<style lang="scss">
  .reviews {
    &__inner {
      display: grid;
      margin-top: 24px;

      @include breakpoint("tablet") {
        grid-template-columns: auto 40px 224px;
        margin-top: 40px;
        grid-template-rows: min-content 1fr;
      }

      @include breakpoint("desktop") {
        grid-template-columns: auto 68px 376px;
        margin-top: 48px;
      }
    }

    &__title {
      font-weight: 300;
      font-size: 20px;
      line-height: 28px;
      margin-top: 0;
      margin-bottom: 8px;

      @include breakpoint("tablet") {
        grid-column-start: 1;
        grid-column-end: 2;
        grid-row-start: 1;
        grid-row-end: 2;
        margin-bottom: 0;
      }

      @include breakpoint("desktop") {
        font-size: 32px;
        line-height: 48px;
      }
    }

    .no-reviews &__title {
      margin-bottom: 16px;

      @include breakpoint("tablet") {
        margin-bottom: 0;
      }
    }

    &__stats {
      margin-bottom: 60px;

      @include breakpoint("tablet") {
        grid-column-start: 3;
        grid-column-end: 4;
        grid-row-start: 1;
        grid-row-end: 3;
        margin-bottom: 0;
      }
    }

    .no-reviews &__stats {
      margin-bottom: 32px;

      @include breakpoint("tablet") {
        margin-bottom: 0;
      }
    }

    &__all-reviews {
      grid-column-start: 1;
      grid-column-end: 2;
      grid-row-start: 3;
      grid-row-end: 4;

      @include breakpoint("tablet") {
        grid-column-start: 1;
        grid-column-end: 2;
        grid-row-start: 2;
        grid-row-end: 2;
      }
    }

    .no-reviews &__all-reviews {
      grid-column-start: 1;
      grid-column-end: 2;
      grid-row-start: 2;
      grid-row-end: 3;
      margin-bottom: 24px;

      @include breakpoint("tablet") {
        grid-column-start: 1;
        grid-column-end: 2;
        grid-row-start: 2;
        grid-row-end: 2;
        margin-bottom: 0;
      }
    }

    &__loader {
      color: $blue;
      display: flex;
      justify-content: center;

      @include breakpoint("tablet") {
        grid-row-start: 2;
        grid-column-start: 1;
        grid-column-end: 4;
      }
    }
  }
</style>
